<app-list-loading [items]="years">
    <ng-select
        [items]="years"
        [placeholder]="'translate_year' | translate"
        [clearable]="false"
        [searchable]="false"
        [(ngModel)]="selectedYear"
        (change)="onYearSelected()"
        class="rounded-md border-slate-300 shadow-sm transition-all duration-200 hover:border-primary-400 focus:border-primary-500 focus:ring-2 focus:ring-primary-200"
    >
    </ng-select>
</app-list-loading>
